import styles from "./MapModal.module.css";

export default function Modal({ show, onClose }) {
  if (!show) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <h2>How To Use</h2>

        <p>
          To use: select the regions you are comfortable receiving notifications
          for. Then select your home region (where you are operating from).
          Then please select a way of contacting you and provide as much
          information as you are comfortable providing.
        </p>

        <p>
          <strong>
            We cannot reach you if you don't provide a way to contact you.
          </strong>
        </p>

        <button className={styles.button} onClick={onClose}>
          Got it
        </button>
      </div>
    </div>
  );
}